import { useTheme as useMuiTheme } from '@material-ui/core';
import theme from './theme';
export var useTheme = useMuiTheme;
export * from './ds-types';
export { default as defaultThemeValues } from './defaultThemeValues';
export { default as ThemeProvider } from './ThemeProvider';
export { default as createDesignSystemTheme } from './createDesignSystemTheme';
export default theme;
